import { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { OpenInNewWindowIcon } from '@/components/Elements/OpenInNewWindowIcon/OpenInNewWindowIcon';
import linkStyles from '@/components/Elements/Link/link.module.scss';
import styles from './privacy-notice.module.scss';

const PRIVACY_NOTICE_URL = 'https://www.spottedzebra.co.uk/privacy/privacy';

// Trans replaces the children of the element passed for <privacyLink> with
// the translated link text, so the anchor has to render its children itself.
const PrivacyLink = ({ children }: { children?: ReactNode }) => (
  <a
    className={linkStyles.link}
    href={PRIVACY_NOTICE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="privacy-notice-link"
  >
    {children}
    <OpenInNewWindowIcon />
  </a>
);

// The notice doesn't name Spotted Zebra, so the same wording works for
// co-branded and non-co-branded roles.
const PrivacyNotice = () => (
  <div className={styles.privacyPolicy} data-testid="privacy-notice">
    <Trans i18nKey="privacyNotice.terms" components={{ privacyLink: <PrivacyLink /> }} />
  </div>
);

export default PrivacyNotice;
